export default {
  path: '/home/transfer-approval-whitelist',
  component: () => import('./index.vue'),
};
